unable to read source [project]/packages/src/utils/theme.utils.ts